<template>
	<div>
		<template v-if="mobile">
			<div class="block md:hidden bg-navy text-white py-2 px-8 w-full shadow cursor-pointer hover:opacity-90"
				onclick="scrollToTerms()"
			>
				Proposal valid until {{ pleaseSignByFormatted }}<br>
				<div class="text-xs text-gray-100">Sign to accept</div>
			</div>
		</template>

		<template v-else>
			<div class="flex justify-end">
				<div class="hidden md:block bg-navy text-white py-2 px-4 rounded-md shadow cursor-pointer hover:opacity-90"
					onclick="scrollToTerms()"
				>
					Proposal valid until {{ pleaseSignByFormatted }}<br>
					<div class="text-xs text-gray-100">Sign to accept</div>
				</div>
			</div>
		</template>
	</div>
</template>

<script>
export default {
    props: {
        pleaseSignBy: {
			type: String,
			required: true
		},
        mobile: {
			type: Boolean,
			required: true
		}
    },
    computed: {
        pleaseSignByFormatted() {
			let d = new Date(this.pleaseSignBy);

			return moment(d).format('MM/DD/YYYY');
        },
    },
}
</script>